import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      width: '90%',
      margin: '0 auto',
      // height: '100%',
      display: 'grid',
      alignItems: 'center',
      padding: '24px 47px',
      height: '84.7%',
      overflowY: 'scroll'
    },
    boxForm: {
      display: 'grid',
      gridGap: 63,
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    leftForm: {
      display: 'grid',
      gridRowGap: 24,
    },
    rightForm: {
      display: 'grid',
      gridRowGap: 32,
      gridColumnGap: 20,
      gridTemplateColumns: 'repeat(2, 1fr)',
      alignItems: 'flex-end',
      height: 'fit-content',
    },
    desc: {
      font: theme.custom.font.paragraph,
    },
    dropdown: {
      flex: 1,
      '& .MuiSelect-select-100 label:first-child': {
        font: theme.custom.font.priceSymbol,
        fontSize: 11.11,
      }
    },
    footerModal: {
      height: '15.3%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
      '& div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
      },
    },

    cancelButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "transparent",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
      marginRight: -15,
    },
    nextButton: {
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      border: "none",
      backgroundColor: "#0C85F4",
      borderRadius: "100px",
      color: "white",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: "24px",
      cursor: "pointer",
      width: 95
    },
    nextButtonIconContainer: {
      marginLeft: "7px",
    },
  };
});

export default useStyles;
